/**
 * SAMURAI TCG - Stock Notify Module (再入荷通知リクエスト)
 *
 * Wires up [data-tcg-stock-request] buttons to the global modal
 * (snippets/tcg-stock-notify-modal.liquid). The form does a plain
 * page-navigating POST to /contact — do not convert to fetch: Shopify
 * intercepts the submit for hCaptcha and may 302 to /challenge, which
 * breaks AJAX. Note: on `shopify theme dev` (localhost) the hCaptcha
 * interception fails ("form submit failed network-error") — real
 * submission must be verified on the dev store domain.
 *
 * Success flow: submit stores a *pending* record only. The next page
 * load confirms it (contact_posted=true, or return_to landing back on
 * the product page) before marking the button as requested — a failed
 * captcha/network error therefore never fakes a success state.
 *
 * To migrate to a Back-in-Stock app later: drop this script and the
 * modal render from theme.liquid. Buttons keep their data attributes
 * so an app can hook the same selector.
 */

(function () {
  'use strict';

  var LS_KEY = 'tcg_stock_requests';
  var PENDING_KEY = 'tcg_notify_pending';
  var TTL_MS = 90 * 24 * 60 * 60 * 1000; // 90日で送信済み記録を失効
  var PENDING_TTL_MS = 10 * 60 * 1000; // 送信確認待ちの有効期間

  /* ---------- localStorage (送信済み記録) ---------- */

  function loadRequests() {
    try {
      var data = JSON.parse(localStorage.getItem(LS_KEY)) || {};
      var now = Date.now();
      var pruned = {};
      var changed = false;
      Object.keys(data).forEach(function (k) {
        if (now - data[k] < TTL_MS) pruned[k] = data[k];
        else changed = true;
      });
      if (changed) localStorage.setItem(LS_KEY, JSON.stringify(pruned));
      return pruned;
    } catch (e) {
      return {};
    }
  }

  function saveRequest(pid, vid) {
    try {
      var data = loadRequests();
      data[requestKey(pid, vid)] = Date.now();
      localStorage.setItem(LS_KEY, JSON.stringify(data));
    } catch (e) {
      /* プライベートモード等では永続化を諦める(送信自体は成立する) */
    }
  }

  function requestKey(pid, vid) {
    return pid + ':' + (vid || '_');
  }

  function isRequested(pid, vid) {
    var data = loadRequests();
    if (data[requestKey(pid, vid)] || data[requestKey(pid, '')]) return true;
    // カード(商品単位, vidなし)からの判定は、商品ページでバリアント付きで
    // 送信済みのキー (pid:vid) も送信済み扱いにする
    if (!vid) {
      var prefix = pid + ':';
      return Object.keys(data).some(function (k) {
        return k.indexOf(prefix) === 0;
      });
    }
    return false;
  }

  /* ---------- ボタン表示 ---------- */

  function markRequested(btn) {
    if (!btn.dataset.tcgNotifyLabel) {
      btn.dataset.tcgNotifyLabel = btn.textContent.trim();
    }
    btn.classList.add('is-requested');
    btn.disabled = true;
    btn.textContent = '✓ Requested';
  }

  function unmarkRequested(btn) {
    if (!btn.classList.contains('is-requested')) return;
    btn.classList.remove('is-requested');
    btn.disabled = false;
    btn.textContent = btn.dataset.tcgNotifyLabel || '📩 Notify Me';
  }

  /* 商品ページのボタンは選択中バリアント、カードのボタンは商品単位で判定 */
  function currentVariantId(btn) {
    if (!btn.hasAttribute('data-tcg-notify-use-variant')) return '';
    var select = document.getElementById('tcg-variant-select');
    if (select) return select.value;
    var hidden = document.getElementById('tcg-product-variant-id');
    return hidden ? hidden.value : '';
  }

  function refreshButtons(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('[data-tcg-stock-request]');
    Array.prototype.forEach.call(buttons, function (btn) {
      var pid = btn.getAttribute('data-tcg-stock-request');
      if (isRequested(pid, currentVariantId(btn))) markRequested(btn);
      else unmarkRequested(btn);
    });
  }

  /* ---------- モーダル ---------- */

  var lastTrigger = null; // 閉じた時にフォーカスを戻す先

  function getModal() {
    return {
      overlay: document.getElementById('tcg-notify-overlay'),
      modal: document.getElementById('tcg-notify-modal'),
      form: document.getElementById('tcg-notify-form'),
    };
  }

  function setField(form, name, value) {
    var input = form.querySelector('[data-tcg-notify-field="' + name + '"]');
    if (input) input.value = value || '';
  }

  function infoFromButton(btn) {
    var pid = btn.getAttribute('data-tcg-stock-request');
    var title = btn.getAttribute('data-tcg-product-title') || document.title;
    var url =
      btn.getAttribute('data-tcg-product-url') ||
      (window.shopUrl || '') + location.pathname;
    var vid = currentVariantId(btn);
    var vtitle = '';
    var select = document.getElementById('tcg-variant-select');
    if (vid && select) {
      var opt = select.options[select.selectedIndex];
      vtitle = opt ? opt.getAttribute('data-vtitle') || '' : '';
    }
    if (vtitle === 'Default Title') vtitle = '';
    return { pid: pid, title: title, url: url, vid: vid, variantTitle: vtitle };
  }

  function openModal(info, trigger) {
    var m = getModal();
    if (!m.modal || !m.form) return;

    lastTrigger = trigger || null;

    var display = info.title + (info.variantTitle ? ' (' + info.variantTitle + ')' : '');
    var label = m.modal.querySelector('[data-tcg-notify-product]');
    if (label) label.textContent = display;

    setField(m.form, 'title', info.title);
    setField(m.form, 'url', info.url);
    setField(m.form, 'variant', info.variantTitle);
    setField(m.form, 'pid', info.pid);
    setField(m.form, 'vid', info.vid);
    // 本文は顧客ではなく店舗オーナー宛の通知メールに載るので日本語のまま (2026-07-31)
    setField(m.form, 'body', '【再入荷リクエスト】' + display + '\n' + info.url);

    // return_to は同一オリジンの相対パスのみ (クエリも保持: ?variant= 等)。
    // 効かない環境でも /contact の成功メッセージが出るだけなので実害なし。
    var path = '';
    try {
      var u = new URL(info.url, location.origin);
      path = u.pathname + u.search;
    } catch (e) {
      path = location.pathname + location.search;
    }
    setField(m.form, 'return', path);

    if (m.overlay) m.overlay.classList.add('is-open');
    m.modal.hidden = false;

    var email = document.getElementById('tcg-notify-email');
    if (email) {
      setTimeout(function () {
        email.focus();
      }, 50);
    }
  }

  function closeModal() {
    var m = getModal();
    if (!m.modal || m.modal.hidden) return;
    if (m.overlay) m.overlay.classList.remove('is-open');
    m.modal.hidden = true;
    if (lastTrigger && document.contains(lastTrigger)) {
      lastTrigger.focus();
    }
    lastTrigger = null;
  }

  /* Tabフォーカスをモーダル内で循環させる */
  function trapFocus(ev, modal) {
    if (ev.key !== 'Tab') return;
    var focusables = modal.querySelectorAll(
      'button:not([disabled]), input:not([disabled]), a[href]'
    );
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (ev.shiftKey && document.activeElement === first) {
      ev.preventDefault();
      last.focus();
    } else if (!ev.shiftKey && document.activeElement === last) {
      ev.preventDefault();
      first.focus();
    }
  }

  /* ---------- 送信成功の確認 (pending → confirmed) ---------- */

  function setPending(pid, vid) {
    try {
      sessionStorage.setItem(
        PENDING_KEY,
        JSON.stringify({
          pid: pid,
          vid: vid,
          path: location.pathname,
          ts: Date.now(),
        })
      );
    } catch (e) {
      /* noop */
    }
  }

  /*
   * POSTはページ遷移するため、成功判定は次のページロードで行う:
   *  - /contact 着地: URLに contact_posted=true が付く
   *  - return_to が効いた場合: 元の商品ページに戻ってくる
   * どちらでもなければ (challenge失敗・離脱等) pending は確認されず、
   * ボタンは送信済みにならない。
   */
  function confirmPending() {
    var raw = null;
    try {
      raw = sessionStorage.getItem(PENDING_KEY);
    } catch (e) {
      return;
    }
    if (!raw) return;

    var pending;
    try {
      pending = JSON.parse(raw);
    } catch (e) {
      sessionStorage.removeItem(PENDING_KEY);
      return;
    }

    var fresh = Date.now() - pending.ts < PENDING_TTL_MS;
    var posted = /(^|[?&])contact_posted=true/.test(location.search);
    var returned = fresh && location.pathname === pending.path;

    if (posted || returned) {
      sessionStorage.removeItem(PENDING_KEY);
      saveRequest(pending.pid, pending.vid);
      if (window.TCGToast) {
        window.TCGToast.show("Thanks — we'll email you when it's back in stock", 'success', 4000);
      }
    } else if (!fresh) {
      sessionStorage.removeItem(PENDING_KEY);
    }
  }

  /* ---------- イベント ---------- */

  function init() {
    // クリックデリゲート (tcg-cart.js と同じパターン)
    document.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-tcg-notify-close]')) {
        closeModal();
        return;
      }
      if (ev.target.id === 'tcg-notify-overlay') {
        closeModal();
        return;
      }

      var btn = ev.target.closest('[data-tcg-stock-request]');
      if (!btn) return;
      ev.preventDefault();

      // 絞り込み等でグリッドが再描画された後でも送信済みなら再送させない
      var pid = btn.getAttribute('data-tcg-stock-request');
      if (isRequested(pid, currentVariantId(btn))) {
        markRequested(btn);
        return;
      }
      openModal(infoFromButton(btn), btn);
    });

    document.addEventListener('keydown', function (ev) {
      var m = getModal();
      if (!m.modal || m.modal.hidden) return;
      if (ev.key === 'Escape') {
        closeModal();
        return;
      }
      trapFocus(ev, m.modal);
    });

    // 送信時: preventDefault しない(ページ遷移POST)。pending記録のみ。
    var m = getModal();
    if (m.form) {
      m.form.addEventListener('submit', function () {
        var pid = m.form.querySelector('[data-tcg-notify-field="pid"]').value;
        var vid = m.form.querySelector('[data-tcg-notify-field="vid"]').value;
        setPending(pid, vid);
      });
    }

    // 商品ページ: バリアント切替で送信済み表示を選択中バリアントに追従
    var select = document.getElementById('tcg-variant-select');
    if (select) {
      select.addEventListener('change', function () {
        refreshButtons();
      });
    }

    // 送信確認 → 送信済みボタンの復元 (この順で。confirmが localStorage を更新する)
    confirmPending();
    refreshButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
